// eslint-disable-next-line import/no-extraneous-dependencies
import { createBaseTransport } from '@spotify-internal/transport';

export function createTransportObj() {
  return createBaseTransport({
    providers: {
      async endpoints() {
        return {
          webgate: 'https://generic.wg.spotify.com',
          webapi: 'https://api.spotify.com',
        };
      },
      token: () => Promise.resolve(''),
    },
  });
}
